import React from 'react'

function ActivityLog() {
  return (
    <div>ActivityLog</div>
  )
}

export default ActivityLog